import { render, staticRenderFns } from "./SurveyItem.vue?vue&type=template&id=f88a8a00&scoped=true&"
import script from "./SurveyItem.vue?vue&type=script&lang=ts&"
export * from "./SurveyItem.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyItem.vue?vue&type=style&index=0&id=f88a8a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88a8a00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f88a8a00')) {
      api.createRecord('f88a8a00', component.options)
    } else {
      api.reload('f88a8a00', component.options)
    }
    module.hot.accept("./SurveyItem.vue?vue&type=template&id=f88a8a00&scoped=true&", function () {
      api.rerender('f88a8a00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/SurveyItem.vue"
export default component.exports